import { Outlet } from 'react-router-dom';

const NotFoundLayout = () => {
  return <Outlet />;
};

export default NotFoundLayout;
